import api from './api'

// Saved JQL filters (your own and shared ones). Results come from taskService.searchJql.
export const savedFilterService = {
  list: async () => {
    const response = await api.get('/saved-filters')
    return response.data
  },

  create: async ({ name, jql, description, is_shared }) => {
    const response = await api.post('/saved-filters', { name, jql, description, is_shared })
    return response.data
  },

  update: async (id, changes) => {
    const response = await api.put(`/saved-filters/${id}`, changes)
    return response.data
  },

  remove: async (id) => {
    const response = await api.delete(`/saved-filters/${id}`)
    return response.data
  }
}
